import { FC } from 'react';

import { AllEntryTypes } from '../../models/Content';
import {
    isContentItemBanner,
    isContentItemBlockArticles,
    isContentItemBlockContent,
    isContentItemBlockCta,
    isContentItemBlockFaq,
    isContentItemBlockLegalText,
    isContentItemBlockProducts,
    isContentItemBlockPromo,
    isContentItemBlockQuickLink,
    isContentItemBlockText,
    isContentItemBlockValuePrompt,
    isContentItemBlockWidget,
    isContentItemBlogSection,
    isContentItemLeadForm,
} from '../../utils/typeGuards';
import { BlockArticles } from '../BlockArticles/BlockArticles';
import { BlockContent } from '../BlockContent/BlockContent';
import { BlockCta } from '../BlockCta/BlockCta';
import { BlockFaq } from '../BlockFaq/BlockFaq';
import { BlockHeroBanner } from '../BlockHeroBanner/BlockHeroBanner';
import { BlockLegalText } from '../BlockLegalText/BlockLegalText';
import { BlockProducts } from '../BlockProducts/BlockProducts';
import { BlockPromo } from '../BlockPromo/BlockPromo';
import { BlockQuickLink } from '../BlockQuickLink/BlockQuickLink';
import { BlockText } from '../BlockText/BlockText';
import { BlockValuePrompt } from '../BlockValuePrompt/BlockValuePrompt';
import { BlockWidget } from '../BlockWidget/BlockWidget';
import { BlogSection } from '../BlogSection/BlogSection';
import { LeadForm } from '../LeadForm/LeadForm';

type Props = {
    contentItem?: AllEntryTypes;
};

export const ContentBlock: FC<Props> = ({ contentItem }) => {
    if (isContentItemBanner(contentItem)) {
        return <BlockHeroBanner contentItems={[contentItem]} forcedH2Heading={true} />;
    }
    if (isContentItemBlockContent(contentItem)) {
        return <BlockContent contentItem={contentItem} />;
    }
    if (isContentItemBlockProducts(contentItem)) {
        return <BlockProducts contentItem={contentItem} />;
    }
    if (isContentItemBlockPromo(contentItem)) {
        return <BlockPromo contentItem={contentItem} />;
    }
    if (isContentItemBlockQuickLink(contentItem)) {
        return <BlockQuickLink contentItem={contentItem} />;
    }
    if (isContentItemBlockText(contentItem)) {
        return <BlockText contentItem={contentItem} />;
    }
    if (isContentItemBlockValuePrompt(contentItem)) {
        return <BlockValuePrompt contentItem={contentItem} />;
    }
    if (isContentItemBlockWidget(contentItem)) {
        return <BlockWidget contentItem={contentItem} />;
    }
    if (isContentItemBlockFaq(contentItem)) {
        return <BlockFaq contentItem={contentItem} />;
    }
    if (isContentItemBlockArticles(contentItem)) {
        return <BlockArticles contentItem={contentItem} />;
    }
    if (isContentItemBlockCta(contentItem)) {
        return <BlockCta contained={true} contentItem={contentItem} />;
    }
    if (isContentItemBlockLegalText(contentItem)) {
        return <BlockLegalText contentItem={contentItem} />;
    }
    if (isContentItemBlogSection(contentItem)) {
        return <BlogSection contentItem={contentItem} />;
    }
    if (isContentItemLeadForm(contentItem)) {
        return <LeadForm contentItem={contentItem} showDefaultOpenModalButton={true} />;
    }

    // unknown entry type
    return null;
};
